const Categories = require('../model/Categories');
const ChannelDefinition = require('../model/ChannelDefinition');

class MetaCommerceFeedChannel extends ChannelDefinition {
	id = 'meta-commerce-feed';
	title = 'Meta Commerce Feed';
	description = 'List your products on Instagram and Facebook using a product feed, without the full Meta Commerce integration.';
	category = Categories.SOCIAL_COMMERCE;
	iconUrl = 'https://go.near.st/hubfs/channels/meta.svg';
	tag = 'Beta';
	comingSoon = true;
	feedExport = true;

	worksWith = ['storefront', 'product-reservations', 'local-checkout'];

	longDescription = `
## Overview
Get your products listed on Instagram and Facebook via a product feed. This is a lightweight alternative to the full Meta Commerce integration — ideal if you want to manage your own Meta Commerce catalogue and simply need a feed URL.

## How it works
NearSt generates a product feed from your live inventory that can be imported into your Meta Commerce Manager catalogue. Contact our support team to get set up.

## Requirements
- An active NearSt inventory connection
- A Meta Business Manager account with at least one Facebook page or Instagram profile
- Product data (titles, descriptions, and images) for your inventory
- Product page links for each product — either from your own website or via a NearSt Storefront

Please check the catalogue setup instructions provided by Meta for up-to-date information on getting your products live using this feed.
	`;
}

module.exports = MetaCommerceFeedChannel;
